import React from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';

import sessionUtil from '@common/helpers/sessionStorage.utils';

import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';

import Field from '@common/components/validation/field.validation';

import Suggestion from '@common/components/suggestion/suggestion.component';
import AccessControl from '@common/components/accessControl/accessControl.component';

import Button from '@material-ui/core/Button';
import { Tooltip } from '@material-ui/core';

import { Row, Col } from 'react-bootstrap';

import FocusHelper from '@common/helpers/focus.helper';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    this.state = {
      showLookup: false,
    };
    autoBind(this);

    this.isExterno = sessionUtil.getItem('isExterno');
  }

  get buttonSize() {
    return this.props.TamanhoButons || 10 - (this.props.TamanhoSuggestion || 12);
  }

  onOpenLookup() {
    this.setState({ showLookup: true });
  }

  onCloseLookup() {
    this.setState({ showLookup: false });
  }

  onSelectLookup(onSelect) {
    return (dataItem) => {
      const { mapLookupItem } = this.props;
      const item = mapLookupItem ? mapLookupItem(dataItem) : dataItem;
      onSelect(item);
      this.onCloseLookup();
    };
  }

  onChange(field, form) {
    return (e) => {
      form.setFieldValue(this.props.name, e);
      this.dispatchChanges(e, form, field);
    };
  }

  onChildChanged(value, form) {
    const { editavel } = this.props;
    if (editavel) form.setFieldValue(this.props.name, value);
  }

  renderButtons(form, value) {
    const { buttons, isView } = this.props;

    if (!buttons) return null;

    let renderedButtons = [];

    if (isView) {
      renderedButtons = buttons.filter((item) => item.showOnView);
    } else {
      renderedButtons = buttons;
    }

    return renderedButtons.map((item, i) => {
      let disabled = item.disabled !== undefined ? item.disabled : !value;

      return (
        <>
          {this.isExterno && (
            <div style={item.style ?? { paddingTop: '12px' }}>
              <Tooltip title={item.title}>
                <Button
                  variant="contained"
                  color="primary"
                  className={'mt-2'}
                  style={{
                    display: 'flex',
                    height: '38px',
                    marginLeft: '16px',
                    cursor: 'pointer',
                    marginTop: '19px !important',
                  }}
                  onClick={!disabled ? () => item.onClick(form.values) : null}
                  disabled={isView}
                >
                  <i className={`pointer-events-none ${item.icon}`} />
                </Button>
              </Tooltip>
            </div>
          )}
          {!this.isExterno && (
            <div style={item.style ?? { paddingTop: '1px' }}>
              <AccessControl key={i} name={item.route} url={item.url}>
                <label style={{ lineHeight: '1' }}>&nbsp;</label>
                <span
                  style={{ display: 'inline-block', width: '30px', marginLeft: '16px', cursor: 'pointer' }}
                  title={item.title}
                  onClick={!disabled ? () => item.onClick(form.values) : null}
                >
                  <button
                    type="button"
                    className="btn btn-primary btn-custom mr-3 pointer-events-none"
                    disabled={disabled}
                  >
                    <i className={`pointer-events-none ${item.icon}`} />
                  </button>
                </span>
              </AccessControl>
            </div>
          )}
        </>
      );
    });
  }

  componentDidMount() {
    this.setFocus();
  }

  setFocus() {
    const { name, setFocus } = this.props;
    if (setFocus) FocusHelper.focus(name);
  }

  renderComponent() {
    const { props } = this;
    const {
      Label,
      Tooltip,
      Obrigatorio,
      Desabilitado,
      EnableLookup,
      Placeholder,
      lookup,
      service,
      mapItem,
      parameters,
      name,
      editavel,
      Tamanho,
      labelKey,
      lookupStyle,
      Linhas,
      buttons,
      ExibeDescricao,
      LimiteCaracteres,
      isView,
    } = props;

    return (
      <Field {...props}>
        {({ value, hasError, onChange, onChangeAsync, onBlur, form }) => {
          return (
            <Row>
              <Col>
                <LabeledInput {...props}>
                  <Suggestion
                    className={`${hasError ? 'span-input-invalid' : ''}`}
                    value={value || ''}
                    name={name}
                    disabled={Desabilitado}
                    required={Obrigatorio}
                    onChange={onChangeAsync}
                    onBlur={props.onBlur ? onBlur : undefined}
                    service={service}
                    parameters={parameters}
                    isView={isView}
                    title={Tooltip || Label}
                    placeholder={Placeholder || Label}
                    mapItem={mapItem}
                    allowCustom={editavel}
                    labelKey={labelKey}
                    maxLength={Tamanho}
                    callbackParent={(value) => {
                      if (this.props.editavel) onChangeAsync(value);
                    }}
                    Linhas={Linhas}
                    ExibeDescricao={ExibeDescricao}
                    LimiteCaracteres={LimiteCaracteres}
                  />
                </LabeledInput>
              </Col>
              {lookup && (
                <Col lg={this.buttonSize}>
                  <div
                    className="container-lookup div-button-right"
                    style={lookupStyle ? lookupStyle : { paddingTop: '1px' }}
                  >
                    <label style={{ lineHeight: '1' }}>&nbsp;</label>
                    <span
                      style={{ display: 'inline-block', width: '28px', cursor: 'pointer' }}
                      title={'Pesquisar'}
                      onClick={!Desabilitado || EnableLookup ? this.onOpenLookup : null}
                    >
                      <button
                        type="button"
                        style={{ width: '28px' }}
                        className="btn btn-primary btn-custom mr-3 pointer-events-none"
                        disabled={Desabilitado && !EnableLookup}
                      >
                        <i className={'pointer-events-none fa fa-search'} />
                      </button>
                    </span>
                    {React.cloneElement(lookup, {
                      onSelect: this.onSelectLookup(onChange).bind(this),
                      onClose: this.onCloseLookup.bind(this),
                      show: this.state.showLookup,
                    })}
                  </div>
                </Col>
              )}
              {buttons?.length > 0 && this.renderButtons(form, value)}
            </Row>
          );
        }}
      </Field>
    );
  }

  renderView() {
    const { buttons } = this.props;

    return (
      <Field {...this.props}>
        {({ form, value }) => {
          return (
            <Row>
              <Col>
                <LabeledInput {...this.props} Obrigatorio={false}>
                  <span>
                    <label className="form-control" style={{ display: 'inline-block' }}>
                      {typeof value == 'object' ? value[`${this.props.labelKey || 'Exibicao'}`] : value}
                    </label>
                  </span>
                </LabeledInput>
              </Col>
              {buttons?.length > 0 && this.renderButtons(form, value)}
            </Row>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>{_.isObject(field?.value) ? field.value.Exibicao || '' : field.value || ''}</label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
